import React from "react";

const ResourceCard = ({ icon, title, link }) => (
  <a href={link} className="resourceCard" target="_blank" rel="noopener noreferrer">
    <img loading="lazy" src={icon} alt={title} className="resourceIcon" />
    <h3 className="resourceTitle">{title}</h3>
  </a>
);

const ResourcesSection = () => {
  const resources = [
    {
      icon: "/icons/icon-installation.svg",
      title: "Installation",
      link: "/en/installation/", // Add your link here
    },
    {
      icon: "/icons/icon-administration.svg",
      title: "Administration",
      link: "/en/docs/administration", // Add your link here
    },
    {
      icon: "/icons/icon-developer-tools.svg",
      title: "Developer Tools",
      link: "/en/docs/developer-tools", // Add your link here
    },
    {
      icon: "/icons/icon-release-notes.svg",
      title: "Release Notes",
      link: "/en/docs/release-notes", // Add your link here
    },
  ];

  return (
    <section className="resourcesSection">
      <div className="resourcesHeader">
        <h2 className="resourcesTitle">
          Helpful Resources for a Jumpstart
        </h2>
        <a href="https://docs.sysdig.com/en/docs/sysdig-secure/" className="learnMoreButton">
          Learn more
          <img
            loading="lazy"
            src="/icons/icon-go.svg"
            alt=""
            className="buttonIcon"
          />
        </a>
      </div>
      <div className="resourcesGrid">
        {resources.map((resource, index) => (
          <ResourceCard key={index} {...resource} />
        ))}
      </div>
    </section>
  );
};

export default ResourcesSection;
